"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Textarea", {
    enumerable: true,
    get: function() {
        return Textarea;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _renderTextarea = require("./renderTextarea");
const _useTextarea = require("./useTextarea");
const _useTextareaStylesstyles = require("./useTextareaStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Textarea = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTextarea.useTextarea_unstable)(props, ref);
    (0, _useTextareaStylesstyles.useTextareaStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTextareaStyles_unstable')(state);
    return (0, _renderTextarea.renderTextarea_unstable)(state);
});
Textarea.displayName = 'Textarea';
